import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type { ReactNode } from 'react'
import Icon from '../../components/icon'

export function DiscoverSortableCard({
  id,
  title,
  position,
  disabled,
  children,
}: {
  id: string
  title: string
  position?: number
  disabled: boolean
  children: ReactNode
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled })
  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      className={`relative min-w-0 space-y-3 rounded-2xl ${
        isDragging ? 'z-20 bg-white shadow-xl ring-2 ring-primary' : ''
      }`}
    >
      {position !== undefined && (
        <div className="flex items-center justify-between gap-3 rounded-lg bg-gray-bg px-3 py-2">
          <span className="text-sm font-medium">Position {position}</span>
          <button
            ref={setActivatorNodeRef}
            {...attributes}
            {...listeners}
            type="button"
            disabled={disabled}
            aria-label={`Drag ${title} to change position`}
            className="flex touch-none items-center gap-2 rounded-md p-2 text-sm text-sec-black cursor-grab active:cursor-grabbing disabled:cursor-not-allowed disabled:opacity-40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
          >
            <Icon id="rearrange" width={20} height={20} />
            Drag
          </button>
        </div>
      )}
      {children}
    </div>
  )
}
